import React, { Component } from 'react';
import { connect } from 'react-redux';
import {ONLINESTATUS} from '../../../../utils/questionManageType'

import axios from 'axios'
import API  from '../../../../API/api';
import {Button, Input, Row, Col ,message,Modal, Radio,Popconfirm,Tooltip} from 'antd';
import {PropTypes} from 'prop-types';
import * as action from '../action'

const ButtonGroup = Button.Group;
class DailyError extends Component {
    static contextTypes = {
        router: PropTypes.object.isRequired
    };
    state = {

    }


    componentDidMount(){
    }

    shouldComponentUpdate(nextProps,nextState){
        if(nextProps.bookCurrent!==this.props.bookCurrent){
            this.getAssistList(nextProps)
        }
    		if(nextProps.handleAssist){
            this.props.setPropsAssistCurrent(nextProps.handleAssist)
        		this.props.setHandleAssist('')
        }
        return true
    }


    //---------教辅相关内容

    getAssistList=(props=this.props)=>{
        let data = {
            book_id:props.bookCurrent||(props.bookList[0]&&props.bookList[0].book_id)//用nextProps的bookCurrent
        }
        this.props.getAssistList(data,()=>{
        		if(props.handleAssist){
        			this.props.setPropsAssistCurrent(props.handleAssist)
        			this.props.setHandleAssist('')
        		}else if(this.props.assistList.length){
        			 this.props.setPropsAssistCurrent(this.props.assistList[0].assist_id,this.props.assistList[0])
        		}else{
                 this.props.setPropsAssistCurrent('')
            }

        })
    }

    changeAssist=(assist)=>{//更换教辅
        this.props.setPropsAssistCurrent(assist.assist_id,assist)
    }
    openEditAssist = (val)=>{//打开教辅修改
        this.setState({visibleAssist:true,editAssist:val,name:val.name,mark:val.mark,assistType:val.type,assistIsPublic:val.is_public})
    }
    addEditAssist = ()=>{//教辅添加
        this.setState({visibleAssist:true,editAssist:{},name:'',mark:'',assistType:'',assistIsPublic:'1'})
    }
    editAssist = ()=>{//教辅修改
        if(this.state.assistType===''){
            return message.error('请选择教辅类型')
        }
        if(this.state.name===''){
            return message.error('请填写名称')
        }
        let data ={
            name:this.state.name,
            mark:this.state.mark,
            type:this.state.assistType,
            is_public:this.state.assistIsPublic,
        }
        if(this.state.editAssist.assist_id){//编辑的情况
            data.assist_id = this.state.editAssist.assist_id
            axios.post(API.FRAMEEWORK_ASSIST_EDIT, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.props.assistList.forEach(d=>{
                        if(d.assist_id===this.state.editAssist.assist_id){
                            d.name = this.state.name
                            d.mark = this.state.mark
                            d.is_public = this.state.assistIsPublic
                            d.type = this.state.assistType
                        }
                    })//成功后直接直接赋值
                    this.setState({visibleAssist:false})
                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})

        }else{
            //添加的情况
            data.book_id = this.props.bookCurrent
            axios.post(API.FRAMEEWORK_ASSIST_ADD, data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    message.success(res.message)
                    this.getAssistList()
                    this.setState({visibleAssist:false})

                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
        }

    }

    delAssist = (id)=>{//删除教辅
        let data ={
            assist_id:id,
        }
        axios.post(API.FRAMEEWORK_ASSIST_DEL, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message)
                this.getAssistList()
                this.props.setPropsAssistCurrent((this.props.assistList[0]&&this.props.assistList[0].assist_id)||'-1',this.props.assistList[0])

            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onlineAssist= (id)=>{//上线
        let data ={
            assist_id:id,
        }
        axios.post(API.FRAMEEWORK_ASSIST_ONLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getAssistList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onlineTestAssist= (id)=>{//上测试
        let data ={
            assist_id:id,
            preview_type:this.state.preview_type,
        }
        axios.post(API.FRAMEEWORK_ASSIST_TEST, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getAssistList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }

    offlineAssist= (id)=>{//下线
        let data ={
            assist_id:id,
        }
        axios.post(API.FRAMEEWORK_ASSIST_OFFLINE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success('成功 次日生效')
                this.getAssistList()
            }else{
                message.error(res.message)
            }
        },()=>{message.error("网络错误！")})
    }
    onAssistDragStart= (e,val,i)=>{//课本移动
        this.setState({dragAssistIndex:i})
    }
    onAssistDragEnd= (e,val,i)=>{//课本移动
        //
    }
    moveAssist= (e,i)=>{//课本移动

        let list = this.props.assistList
        let assist = list.splice(this.state.dragAssistIndex,1)[0]
        list.splice(i,0,assist)
        this.setState({dragAssistIndex:i})
        this.props.setPropsAssistList(list)
    }
    moveAssistDrop=(e)=>{
        let data = {
            assist_id:this.props.assistList[this.state.dragAssistIndex].assist_id,
            order_num:this.state.dragAssistIndex,
        }
        axios.post(API.FRAMEEWORK_ASSIST_MOVE, data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                // message.success(res.message)
            }else{
                message.error(res.message)
                this.getAssistList()
            }
        },()=>{message.error("网络错误！")})
    }

    render(){

        return (
            <div>


                <Row style={{marginBottom: 20}}>
                    <Col span={2} className="popup-input-title" style={{
                        lineHeight: '28px',
                        textAlign: 'center',
                        paddingRight: '5px',
                        fontSize: '15px',
                        fontWeight: '500'
                    }}><label>教辅：</label></Col>
                    <Col span={22} style={{paddingLeft: 10, textAlign: 'left'}}>
                        {
                            this.props.assistList && this.props.assistList.map((val, key) =>

                                    <ButtonGroup size={'small'} style={{marginRight: 20, marginBottom: 10}} key={val.assist_id+key}
                                                 draggable={!!(this.props.user.role_assist && this.props.user.role_assist.moveAssist)}
                                                 onDragStart={(e) => {
                                                     this.onAssistDragStart(e, val, key)
                                                 }}
                                                 onDragEnter={(e) => {
                                                     this.moveAssist(e, key)
                                                 }}
                                                 onDragEnd={(e) => {
                                                     this.moveAssistDrop(e, key)
                                                 }}>
                                        <Tooltip title={val.assist_id}>
                                            <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                    onClick={() => {
                                                        this.changeAssist(val)
                                                    }}
                                                    value={val.assist_id}>{val.name}({parseInt(val.is_public) === 1 ? '公开' : '本地'})--{ONLINESTATUS[val.online_status]}
                                            </Button>
                                        </Tooltip>

                                        {
                                            this.props.user.role_assist && this.props.user.role_assist.editAssist &&
                                            <Tooltip title={'添加教辅'} mouseEnterDelay={1}>
                                                <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                 onClick={() => {
                                                                     this.openEditAssist(val)
                                                                 }}
                                                                 icon="edit"/>
                                            </Tooltip>

                                        }
                                        {
                                            this.props.user.role_assist && this.props.user.role_assist.delAssist &&
                                            <Popconfirm title="确认删除吗？" onConfirm={(e) => {
                                                this.delAssist(val.assist_id)
                                            }} okText="确认" cancelText="取消">
                                                <Tooltip title={'删除'} mouseEnterDelay={1}>
                                                    <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                     icon="delete"/>
                                                </Tooltip>

                                            </Popconfirm>
                                        }
                                        {
                                            this.props.user.role_assist && this.props.user.role_assist.online &&
                                            <Popconfirm title="确认上线吗？" onConfirm={(e) => {
                                                this.onlineAssist(val.assist_id)
                                            }} okText="确认" cancelText="取消">
                                                <Tooltip title={'上线'} mouseEnterDelay={1}>
                                                    <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                                   icon="to-top"/>
                                                </Tooltip>

                                            </Popconfirm>
                                        }
                                        {
                                            this.props.user.role_assist && this.props.user.role_assist.offline &&
                                            <Popconfirm title="确认下线吗？" onConfirm={(e) => {
                                                this.offlineAssist(val.assist_id)
                                            }} okText="确认" cancelText="取消">
                                                <Tooltip title={'下线'} mouseEnterDelay={1}>
                                                    <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''} style={{borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                                   icon="arrow-down"/>
                                                </Tooltip>

                                            </Popconfirm>
                                        }
                                        {
                                            this.props.user.role_assist && this.props.user.role_assist.onlineTest &&
                                            <Tooltip title={'上测试'} mouseEnterDelay={1}>
                                                <Button type={this.props.assistCurrent === val.assist_id ? 'primary' : ''}
                                                                               onClick={()=>{this.setState({preview_type:'qa',visibleOnTest:true,Modal_assist_id:val.assist_id})}} style={{color: '#0f0', fontWeight: 'blod',borderColor:'2'===''+val.online_status?'rgb(90, 155, 254)':'d9d9d9'}}
                                                                               icon="to-top" />
                                            </Tooltip>


                                        }
                                    </ButtonGroup>

                            )
                        }
                        <Modal visible={this.state.visibleOnTest}
                               onOk={(e) => {this.onlineTestAssist(this.state.Modal_assist_id);this.setState({visibleOnTest:false})}}
                               onCancel={() => {
                                   this.setState({visibleOnTest: false})}}>
                            <Radio.Group onChange={(e)=>{this.setState({preview_type:e.target.value});}} value={this.state.preview_type}>

                                <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'jiaoyan'}>教研环境</Radio>
                                <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'dev'}>开发环境</Radio>
                                <Radio style={{display:'block',height: '30px',lineHeight: '30px'}} value={'qa'}>QA环境</Radio>

                            </Radio.Group>
                        </Modal>
                        {
                            this.props.user.role_assist && this.props.user.role_assist.addAssist &&
                            <ButtonGroup style={{marginRight: 20, marginBottom: 10, fontWeight: '600'}}>
                                <Button type={'primary'}
                                        size={'small'}
                                        onClick={() => {
                                            this.addEditAssist()
                                        }}
                                        icon="plus"/>
                            </ButtonGroup>
                        }

                    </Col>
                </Row>


                {/*教辅 修改 增加的模态框*/}
                <Modal
                    title={'教辅管理'}
                    visible={this.state.visibleAssist}
                    onOk={this.editAssist}
                    onCancel={() => {
                        this.setState({visibleAssist: false})
                    }}
                    okText={'确定'}
                >

                    <Row className="row">
                        <Col span={3}>课本id：</Col>
                        <Col span={21}>
                            <Input placeholder="输入课本id" disabled value={this.props.bookCurrent}/>
                        </Col>
                    </Row>
                    <Row className="row" style={{marginTop: 20}}>
                        <Col span={3}>教辅名称：</Col>
                        <Col span={21}>
                            <Input placeholder="输入名称(必填)" value={this.state.name}
                                   onChange={e => this.setState({name: e.target.value})}/>
                        </Col>
                    </Row>
                    <Row className="row" style={{marginTop: 20}}>
                        <Col span={3}>教辅类型：</Col>
                        <Col span={21}>

                            <Radio.Group value={this.state.assistType || ''} onChange={(e) => {
                                this.setState({assistType: e.target.value})
                            }}>
                                {
                                    this.props.filterAssist.map((val, key) =>
                                        <Radio value={val.type} key={val.type}>{val.name}</Radio>
                                    )
                                }

                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row className="row" style={{marginTop: 20}}>
                        <Col span={3}>概要</Col>
                        <Col span={21}>
                            <Input placeholder="输入概要(非必填)" value={this.state.mark}
                                   onChange={e => this.setState({mark: e.target.value})}/>
                        </Col>
                    </Row>
                    <Row className="row" style={{marginTop: 20}}>
                        <Col span={3}>概要</Col>
                        <Col span={21}>
                            <Radio.Group value={this.state.assistIsPublic || '1'} onChange={(val) => {
                                this.setState({assistIsPublic: val})
                            }}>
                                <Radio value='1'>是</Radio>
                                <Radio value='0'>否</Radio>
                            </Radio.Group>
                        </Col>

                    </Row>
                </Modal>

            </div>
        )
    }
}

function mapState(state) {
    const asstst = state.knowledgeAssist.assist;

    return {
        user:state.user,
        editionCurrent:asstst.editionCurrent,
        editionList:asstst.editionList,
        bookCurrent:asstst.bookCurrent,
        bookList:asstst.bookList,
        assistCurrent:asstst.assistCurrent,
        assist:asstst.assist,
        assistList:asstst.assistList,
        filterList:asstst.filterList,
        filterAssist:asstst.filterAssist,
        handleAssist:asstst.handleAssist,
        handelBook:asstst.handelBook,

    };
}

function mapDispatch(dispatch) {
    return{
        setPropsAssistCurrent:(val,assist)=>{
            dispatch(action.setPropsAssistCurrent(val,assist))
        },
        setHandleAssist:(val)=>{
            dispatch(action. setHandleAssist(val))
        },
        getAssistList:(val,cb)=>{
            dispatch(action.getAssistList(val,cb))
        },
        setPropsAssistList:(val)=>{
            dispatch(action.setPropsAssistList(val))
        },
        
    }
}
export default connect(mapState, mapDispatch)(DailyError);


// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/assist/Assist/view.js